import React from 'react';
import { LoginForm} from '../../../components/Admin/Auth';
import { logoEduca } from '../../../assets';
import '../Auth/Auth.scss';

export function AuthTeacherstudents() {

  return (
    <div className='auth'>
      <img src={logoEduca.logoE360} alt="Educa360" className='logo' />
      <LoginForm/>
    </div>
  );
}
